// Special cases
const DEFAULT_PROCESSORS_BY_COUNTRY = {
  de: { mobile: 'PP' },
  at: { mobile: 'PP' },
};

export default DEFAULT_PROCESSORS_BY_COUNTRY;
